// SearchBar.js
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      width: '50%',
      margin: theme.spacing(1),
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Add shadow style here
    },
  },
}));

const SearchBar = ({ onSearch }) => {
  const classes = useStyles();

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    onSearch(searchTerm);
  };

  return (
    <Box className={classes.root} boxShadow={3} p={2} borderRadius={8}>
      <TextField
        id="outlined-search"
        label="Search"
        type="search"
        variant="outlined"
        onChange={handleSearchChange}
      />
    </Box>
  );
};

export default SearchBar;
